import React, { Component } from 'react';
import { Button } from 'reactstrap';

export default class RetryToastAction extends Component {
	state = { retrying: false };

	componentDidMount() {
		this.props.onMount(this.props.remove);
	}

	componentWillUnmount() {
		this.props.onUnmount(this.props.remove);
	}

	handleRetry = (event) => {
		event.stopPropagation();
		if (this.state.retrying) return;
		this.setState({ retrying: true });
		this.props.remove();
		this.props.onRetry();
	};

	render() {
		return (
			<Button
				color="light"
				size="sm"
				className="mt-2"
				disabled={this.state.retrying}
				onClick={this.handleRetry}
			>
				Retry
			</Button>
		);
	}
}
